import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/featureAccess/customer.featureAccess.query.gql"
import type {
  CustomerFeatureAccessQuery,
  CustomerFeatureAccessQueryVariables,
} from "@/v2-backoffice-client/customer/featureAccess/__types__/customer.featureAccess.query"

type Options = QueryHookOptions<
  CustomerFeatureAccessQuery,
  CustomerFeatureAccessQueryVariables
>

export function useCustomerFeatureAccessQuery(options: Options) {
  return useQuery<
    CustomerFeatureAccessQuery,
    CustomerFeatureAccessQueryVariables
  >(query, options)
}
